import React, { useEffect, useState } from 'react';
import { FiClock } from 'react-icons/fi';

interface ElapsedTimerProps {
  fromTimestamp: number; // Unix timestamp in seconds
}

const ElapsedTimer: React.FC<ElapsedTimerProps> = ({ fromTimestamp }) => {
  const [elapsed, setElapsed] = useState('00M');

  useEffect(() => {
    const updateElapsed = () => {
      const now = Math.floor(Date.now() / 1000);
      let diff = now - fromTimestamp;

      // Clamp negative diff to 0
      if (diff < 0) diff = 0;

      const hours = Math.floor(diff / 3600);
      const minutes = Math.floor((diff % 3600) / 60);

      if (hours > 0) {
        setElapsed(`${String(hours).padStart(2, '0')}H : ${String(minutes).padStart(2, '0')}M`);
      } else {
        setElapsed(`${String(minutes).padStart(2, '0')}M`);
      }
    };

    updateElapsed();
    const interval = setInterval(updateElapsed, 1000);

    return () => clearInterval(interval);
  }, [fromTimestamp]);

  return (
    <div className="flex items-center gap-1 text-xs font-medium text-sidebar bg-yellow-100 px-2 py-[2px] rounded-full border border-yellow-400">
      <FiClock className="text-yellow-600" size={14} />
      <span>{elapsed}</span>
    </div>
  );
};

export default ElapsedTimer;
